import React from 'react';
import { Box } from '@mui/material';
import { formatCodeForFlag } from '@/features/translator/signals.ts';
import { getCustomFlagPath } from '@/features/translator/customFlags.ts';

interface LanguageFlagProps {
  languageCode: string;
  size?: 'small' | 'medium';
  style?: React.CSSProperties;
}

export const LanguageFlag: React.FC<LanguageFlagProps> = ({ 
  languageCode, 
  size = 'small',
  style = {} 
}) => {
  if (!languageCode) return null;

  const customFlagPath = getCustomFlagPath(languageCode);
  const flagCode = customFlagPath ? null : formatCodeForFlag(languageCode);
  
  const baseStyle = {
    height: size === 'small' ? '1.2rem' : '1.5rem',
    width: 'auto',
    borderRadius: '12%',
    verticalAlign: 'middle',
    ...style
  };

  const iconStyle = {
    fontSize: size === 'small' ? '1.2rem' : '1.5rem',
    borderRadius: '12%',
    verticalAlign: 'middle',
    ...style
  };

  if (customFlagPath) {
    return (
      <img 
        src={customFlagPath} 
        alt={`${languageCode} flag`} 
        style={baseStyle}
      />
    );
  }

  if (flagCode) {
    return (
      <span 
        className={`fi fi-${flagCode}`} 
        style={iconStyle}
      />
    );
  }

  return null;
};
